import React from 'react';
import { getUrl, getDescText } from '../../common/services/builders';
import PropTypes from 'prop-types';

function CTLFAQListerSearchItem({ entry }) {

    function getCertLabels(arr)
    {
        var certLabels = arr.map((cert, index) => 
            <span key={index} className="category--tag multi">{cert.name}</span>
        );
        return certLabels;
    }


    var category = "FAQ";
    var labels = entry.certifications != null != null ? getCertLabels(entry.certifications) : ""; 


    return (
        <div className="search-result">
            <div className="row">
                <div className="small-6 column">
                    
                    <span className="category--tag">{category}</span>
                </div>
                <div className="small-6 column text-right">
                    {labels}
                </div>
            </div>

            
            <div>
                <h4><a href={getUrl(entry)}>{entry.title}</a></h4>
                <span dangerouslySetInnerHTML={{__html: getDescText(entry)}}></span>

            </div>
        </div>
    );
    
}


CTLFAQListerSearchItem.propTypes = {
    entry: PropTypes.object
};

export default CTLFAQListerSearchItem;